import Permissions from '@/permissions'

const getMeta = (permissions, link) => {
  return {
    permissions,
    groups: 'team',
    breadcrumb: [
      {
        name_en: 'Team',
        name_km: 'ក្រុមការងារត្រួតពិនិត្យសំណង់'
      },
      link
    ]
  }
}

const _team = Permissions.backend.team

export const teamRouters = {
  path: 'team',
  name: 'team',
  component: () => import('@/views/team/Index'),
  redirect: 'team',
  meta: {
    permissions: [_team.manage],
    groups: 'team'
  },
  children: [
    {
      path: '',
      name: 'list-team',
      component: () => import('@/views/team/List'),
      meta: getMeta([_team.list], {
        name_en: 'Team List',
        name_km: 'បញ្ជីក្រុមការងារ'
      })
    },
    {
      path: 'create',
      name: 'create-team',
      component: () => import('@/views/team/Create'),
      meta: getMeta([_team.store], {
        name_en: 'Create Team',
        name_km: 'បន្ថែមក្រុមការងារ'
      })
    },
    {
      path: 'show/:team_uuid',
      name: 'show-team',
      component: () => import('@/views/team/Show'),
      meta: getMeta([_team.show], {
        name_en: 'Show Team',
        name_km: 'បង្ហាញព័ត៌មានក្រុមការងារ'
      })
    },
    {
      path: 'edit/:team_uuid',
      name: 'edit-team',
      component: () => import('@/views/team/Edit'),
      meta: getMeta([_team.edit], {
        name_en: 'Edit Team',
        name_km: 'កែប្រែព័ត៌មានក្រុមការងារ'
      })
    }
  ]
}
